module.exports = __webpack_public_path__ + "static/media/firstFrame.ed538ffc.jpg";